import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserId, setPer, setUserInfo } from '@/utils/auth'; // get token from cookie

export default {
  data: function data() {
    return {
      fullscreenLoading: false,
      iframeurl: '',
      loginOut: false
    };
  },
  created: function created() {
    // sessionStorage.setItem('resourcePath',JSON.stringify({resourcePath:'首页'}))
    // this.$store.dispatch('settings/changeSetting',{
    //   key:'breadcrumb',
    //   value:{resourcePath:'首页'}
    // })
    this.fullscreenLoading = true;
    this.menuData();
    // window.addEventListener(
    //   "message",
    //   (event) => {
    //     console.log('平台message',event)
    //     if (event.data === "loginOut" && !this.loginOut) {
    //       this.loginOut = true;
    //       this.$message({
    //         message: "token失效或过期，返回登录页面",
    //         type: "warning",
    //       });
    //       this.logout();
    //       setTimeout(() => {
    //         this.loginOut = false;
    //       }, 500);
    //     }
    //   },
    //   false
    // );
  },
  mounted: function mounted() {
    var _this = this;
    this.iframeInit();
    window.onresize = function () {
      _this.iframeInit();
    };
  },
  methods: {
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('user/logout');
              case 2:
                _this2.$router.push("/login?redirect=".concat(_this2.$route.fullPath));
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    iframeInit: function iframeInit() {
      var _this3 = this;
      var iframe = this.$refs.iframe;
      var clientHeight = '';
      if (this.$route.meta.sysId === 'LC_IE') {
        clientHeight = document.documentElement.clientHeight - 64;
      } else {
        clientHeight = document.documentElement.clientHeight - 64;
      }
      if (!iframe) {
        return;
      }
      iframe.style.height = "".concat(clientHeight, "px");
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          _this3.fullscreenLoading = false;
        });
      } else {
        iframe.onload = function () {
          _this3.fullscreenLoading = false;
        };
      }
    },
    getSystem: function getSystem() {
      var _this4 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list',
        data: {
          pageNum: 1,
          pageSize: 10000
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          var systemInner = [];
          res.result.records.forEach(function (ele) {
            systemInner.push(ele.systemCategory[0]);
          });
          sessionStorage.setItem('systemInner', JSON.stringify(systemInner));
        }
      }).catch(function (err) {
        _this4.$message.warning(err.message);
      });
    },
    menuData: function menuData() {
      var _this5 = this;
      this.$API.getMenuInfo({
        userId: getUserId()
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
          var sysId, url;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this5.fullscreenLoading = false;
                  if (!(res.code === '0000000000')) {
                    _context2.next = 36;
                    break;
                  }
                  _context2.next = 4;
                  return _this5.getSystem();
                case 4:
                  // setPer(res.result.permissionList);
                  setUserInfo(res.result.user.orgId);
                  if (!sessionStorage.getItem('resourcePath')) {
                    _context2.next = 11;
                    break;
                  }
                  sysId = JSON.parse(sessionStorage.getItem('resourcePath')).systemId;
                  url = JSON.parse(sessionStorage.getItem('resourcePath')).path.split('#');
                  if (sysId === 'LC_PLATFORM') {
                    _this5.$router.push(url[1]);
                  } else {
                    _this5.iframeurl = JSON.parse(sessionStorage.getItem('resourcePath')).path || res.result.resourceList[0].path;
                  }
                  _context2.next = 28;
                  break;
                case 11:
                  if (!res.result.resourceList[0].path) {
                    _context2.next = 15;
                    break;
                  }
                  if (res.result.resourceList[0].systemId === 'LC_PLATFORM') {
                    _this5.$router.push(res.result.resourceList[0].path);
                  } else {
                    _this5.iframeurl = res.result.resourceList[0].path;
                  }
                  _context2.next = 28;
                  break;
                case 15:
                  if (!(res.result.resourceList[0].path == null && res.result.resourceList[0].children.length > 0)) {
                    _context2.next = 25;
                    break;
                  }
                  if (!(res.result.resourceList[0].children[0].path == null)) {
                    _context2.next = 22;
                    break;
                  }
                  _this5.$message({
                    message: '请联系管理员配置首页权限',
                    type: 'warning'
                  });
                  _this5.iframeurl = '';
                  return _context2.abrupt("return");
                case 22:
                  if (res.result.resourceList[0].children[0].systemId === 'LC_PLATFORM') {
                    _this5.$router.push(res.result.resourceList[0].children[0].path.split('#')[1]);
                  } else {
                    _this5.iframeurl = res.result.resourceList[0].children[0].path;
                  }
                case 23:
                  _context2.next = 28;
                  break;
                case 25:
                  _this5.$message({
                    message: '请联系管理员配置首页权限',
                    type: 'warning'
                  });
                  _this5.iframeurl = '';
                  return _context2.abrupt("return");
                case 28:
                  if (!(_this5.iframeurl == null)) {
                    _context2.next = 32;
                    break;
                  }
                  _this5.$message({
                    message: '请联系管理员配置首页权限',
                    type: 'warning'
                  });
                  _this5.iframeurl = '';
                  return _context2.abrupt("return");
                case 32:
                  sessionStorage.setItem('defaultactivemenu', res.result.resourceList[0].resourceId);
                  _this5.$store.dispatch('settings/changeSetting', {
                    key: 'menuArr',
                    value: res.result.resourceList
                  });
                  _this5.$store.dispatch('settings/changeSetting', {
                    key: 'roleTypeArr',
                    value: res.result.roleList
                  });
                  _this5.$store.dispatch('settings/changeSetting', {
                    key: 'userinfo',
                    value: res.result.user
                  });
                case 36:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {});
    }
  }
};